<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/system/setting")
            i.fa.fa-sliders-h
            span.ml-1 {{ $t("ui.settings") }}
    div.row.mb-5
      div.col-md-4
        b-tabs
          b-tab(:title="$t('ui.password')")
            div.card-group
              changePwd
          b-tab(:title="$t('ui.security_code')")
            div.card-group
              changeScrCode
</template>

<script>
import changePwd from "@/components/changePwd.vue";
import changeScrCode from "@/components/changeScrCode.vue";

export default {
  components: {
    changePwd,
    changeScrCode
  }
};
</script>
